module.exports = {
  marketing: '#CC8E00',
  design: '#CF6747',
  'user-experience': '#356E8F',
  'no-code-hacks': '#518679',
  product: '#D29674',
  'real-life-wins': '#D29674',
  ecommerce: '#D29674',
};
